import React from 'react';
import { AgentMark } from './AgentMark';
import { getAgent } from '../../utils/agents';
import type { AgentId } from '../../types/anna';
interface SummonedCardProps {
  agent: AgentId;
  kicker?: string;
  title: string;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

/** Glass card summoned onto the stage by Anna. Footer always sits on the card's bottom edge. */
export function SummonedCard({
  agent,
  kicker,
  title,
  children,
  footer,
  className = ''
}: SummonedCardProps) {
  const a = getAgent(agent);
  return <article className={`glass flex h-full flex-col rounded-2xl p-5 ${className}`} data-id="element-1200" data-mp="1gvug9ojbypc">
      <header className="flex items-center gap-2.5" data-id="element-1201" data-mp="3jq69u6xv1fgx">
        <AgentMark agentId={agent} size="sm" data-id="element-1202" data-mp="3on6ecdf2aa5x" />
        <span className="text-[13px] font-medium text-ink-soft" data-id="element-1203" data-mp="3onyabpckm9wq">{a.name}</span>
        {kicker && <span className="truncate text-[13px] text-ink-muted" data-id="element-1204" data-mp="1hxrsb8z8ad11">· {kicker}</span>}
      </header>
      <h3 className="mt-3 text-[18px] font-semibold leading-snug text-ink" data-id="element-1205" data-mp="1mv0852wwm4z4">{title}</h3>
      {children && <div className="mt-3 flex-1" data-id="element-1206" data-mp="1zucfgkdvfrmt">{children}</div>}
      {footer && <footer className="mt-auto flex flex-wrap items-center gap-2 border-t border-white/[0.07] pt-4" data-id="element-1207" data-mp="1vuvbxwi094ka">{footer}</footer>}
    </article>;
}